module.exports = __webpack_public_path__ + "assets/img/5G.12dcd7c0.jpg";